import { useEffect, useState } from "react";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Alert, Button, ButtonGroup, Card, Col, Container, Dropdown, Form, OverlayTrigger, Row, Spinner, ToggleButton, ToggleButtonGroup, Tooltip } from "react-bootstrap";
import CustomPagint from "../../components/CustomPagint";
import CustomTable from "../../components/CustomTable";
import { deleteNotificationBody, editNotificationBody, getNotificationBody } from "../../redux/moduloNotificaciones/cuerpoNotificacion/actions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import messages from "../../redux/messages";

import { getCompanias } from "../../redux/compania/actions";
import { getNotificationType } from "../../redux/moduloNotificaciones/tipoNotificacion/actions";
import ModalNotification from "../../components/Modulo_Notificaciones/Formulario/ModalNotification";
import { getNotificationVariable } from "../../redux/moduloNotificaciones/variableNotificacion/actions";
import { getNotificationSegment } from "../../redux/moduloNotificaciones/segmentoNotificacion/actions";
import { getCountryUser } from "../../redux/countryUser/actions";
import HistoryModal from "../../components/Modulo_Notificaciones/Historial/HistoryModal";
import { getNotificationHistory } from "../../redux/moduloNotificaciones/NotificationHistory/actions";
import { MODULES } from "./Constants";

const MonitorNotificaciones = () => {
    const [show, setShow] = useState(true);
    const [showHistory, setShowHistory] = useState(false);
    const [historyNotification, setHistoryNotification] = useState({});
    const dispatch = useDispatch()
    const onShowSidebar = () => setShow(show ? false : true);
    const { module } = useParams()

    //obtener código del módulo
    const moduleData = Object.values(MODULES).find(mod => mod.path === `/conf-notificaciones/monitor/${module}`);

    const filters = [
        { id: "titulo", desc: "Título" },
        { id: "pais", desc: "País" },
        { id: "estado", desc: "Estado" },
        { id: "fecha_creacion", desc: "Fecha de creación" },
    ];
    const initialFilters = { offset: 0, limit: 10, tipo_busqueda2: "modulo", filter2: moduleData?.code }
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    //
    const [edit, setEdit] = useState(false);
    const [index, setIndex] = useState(0);
    const [editItem, setEditItem] = useState({});

    //
    const [showModal, setShowModal] = useState(false);
    const [filter, setFilter] = useState("");
    const [validated, setValidated] = useState(false);

    //

    const [tipoBusqueda, setTipoBusqueda] = useState({ id: "titulo", desc: "Título" });

    const {
        loading,
        saveLoading,
        notificationBodiesLength,
        notificationBodies,
        notificationBodyError,
        formError,
    } = useSelector((store) => store.notificationBody)

    const pages = Math.ceil(notificationBodiesLength / limit);

    //Datos para el custom table

    const columns = [
        {
            Header: "Título",
            accessor: "titulo",
            Filter: ""
        },
        {
            Header: "País",
            accessor: "pais",
            Filter: ""
        },
        {
            Header: "Módulo",
            accessor: "modulo",
            Filter: ""
        },
        {
            Header: "Fecha de creación",
            accessor: "fecha_creacion",
            Filter: "",
            Cell: (value) => (
                <div>
                    {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
                </div>
            ),
        },
        {
            id: "customButtons",
            Filter: "",
            Cell: (value) => (
                <div className="button-group" role="group">
                    <OverlayTrigger
                        placement="auto"
                        overlay={<Tooltip>Editar Notificación</Tooltip>}
                    >
                        <Button
                            size="sm"
                            variant="link"
                            type="button"
                            onClick={() => onEdit(value.row.original, value.row.index)}
                        >
                            <i className="material-icons">edit</i>
                        </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="auto"
                        overlay={<Tooltip>Eliminar</Tooltip>}
                    >
                        <Button
                            size="sm"
                            className="text-danger"
                            variant="link"
                            type="button"
                            onClick={() => onDelete(value.row.original.id, value.row.index)}
                        >
                            <i className="material-icons">close</i>
                        </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="auto"
                        overlay={<Tooltip>Historial</Tooltip>}
                    >
                        <Button
                            size="sm"
                            className="text-dark"
                            variant="link"
                            type="button"
                            onClick={() => handleShowHistory(value.row.original.id)}
                        >
                            <i className="material-icons">history</i>
                        </Button>
                    </OverlayTrigger>
                </div>
            ),
        },
        {
            id: "activo",
            Header: "Activo",
            accessor: "estado",
            Filter: "",
            Cell: (value) => (
                <Form>
                    <Form.Check
                        type="switch"
                        style={{ cursor: "pointer" }}
                        id={`custom-switch-${value.row.index}`}
                        label={value.row.original.estado ? "Activo" : "Inactivo"}
                        checked={value.row.original.estado}
                        onChange={() => {
                            const newState = !value.row.original.estado;
                            handleActivate(value.row.original.id, newState);
                        }}
                    />
                </Form>
            ),
        }
    ];

    // Metodos de tipos de notificaciones

    const getNotifications = (off = offset, lim = limit, filt = filter) =>
        dispatch(
            getNotificationBody({
                offset: off,
                limit: lim,
                tipo_busqueda2: "modulo",
                filter2: moduleData?.code,
                tipo_busqueda1: tipoBusqueda.id,
                filter1:
                    tipoBusqueda.id === "fecha_creacion"
                        ? filt !== ""
                            ? !isNaN(filt)
                                ? filt
                                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                                    8
                                )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                                    4
                                )}-${filt.charAt(0)}${filt.charAt(1)}`
                            : filt
                        : filt,
            })
        );

    useEffect(() => {
        getNotifications();
        dispatch(getCompanias(2));
        dispatch(getNotificationType())
        dispatch(getNotificationVariable({
            tipo_busqueda: "modulo",
            filter: moduleData?.code
        }))
        dispatch(getNotificationSegment())
        dispatch(getCountryUser())
    }, [])


    const addCollaboratorType = () => {
        setShowModal(true);
        setEdit(false);
        setEditItem({});
        setValidated(false);
    };

    const onEdit = (item, index) => {
        setIndex(index);
        setEdit(true);
        setEditItem(item);
        setShowModal(true);
        setValidated(false);
    };

    const onSearch = (e) => {
        e.preventDefault();
        setFilter(e.target.filter.value);
        const oOffset = 0;
        setOffset(0);
        setCurrentPage(1);
        getNotifications(oOffset, limit, e.target.filter.value);
    };

    const onSearchActiveInactive = (value) => {
        setFilter(value);
        const oOffset = 0;
        setOffset(oOffset);
        setCurrentPage(1);
        getNotifications(oOffset, limit, value);
    };

    const seeAll = () => {
        const oSearch = "";
        setFilter(oSearch);
        const oOffset = 0;
        setOffset(oOffset);
        setCurrentPage(1);
        getNotifications(oOffset, limit, oSearch);
    };

    const onDelete = (id) => {
        if (window.confirm(messages.preguntaEliminar)) {
            dispatch(deleteNotificationBody(id, initialFilters));
            window.alert("Se borró esta notificación");
        }
    };

    const handleShowHistory = (id) => {
        setShowHistory(true);
        setHistoryNotification(id);
        dispatch(getNotificationHistory({
            tipo_busqueda1: "correo_id",
            filter1: id,
            limit: 10,
            offset: 0
        }))

    }

    const handleActivate = (id, estado) => {
        dispatch(editNotificationBody({ estado: estado }, null, id, null, null, initialFilters))
    }

    return (
        <>
            <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
            <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
            <div className="custom-wrapper">
                <Container fluid>
                    <div>
                        <h1 className="my-2">Monitor de Notificaciones</h1>
                        <h4>MONITOR DE {moduleData?.name.toUpperCase()}</h4>
                        <Form onSubmit={onSearch}>
                            <Row className="justify-content-sm-end align-items-center flex-nowrap">
                                <Col>
                                    <h6>
                                        <b>Busqueda por: {tipoBusqueda.desc}</b>
                                    </h6>
                                </Col>
                                <Col xs="auto">
                                    {tipoBusqueda.id === "estado" ? (
                                        <ToggleButtonGroup type="radio" name="estado" value={filter} onChange={onSearchActiveInactive}>
                                            <ToggleButton id="tbg-btn-1" value={true}>
                                                Activas
                                            </ToggleButton>
                                            <ToggleButton id="tbg-btn-2" value={false}>
                                                Inactivas
                                            </ToggleButton>
                                        </ToggleButtonGroup>

                                    ) : (
                                        <Form.Control
                                            name="filter"
                                            id="filter"
                                            placeholder="Buscar"
                                            className="rounded-pill form-control-sm"
                                            type="search"
                                        ></Form.Control>
                                    )}

                                </Col>
                                <Col xs="auto">
                                    <ButtonGroup>
                                        <Button
                                            onClick={() => seeAll()}
                                            variant="light"
                                            size="sm"
                                            className="rounded-circle mr-1"
                                        >
                                            <i className="material-icons">list</i>
                                        </Button>
                                        <OverlayTrigger
                                            placement="auto"
                                            overlay={
                                                <Tooltip>Crear Notificación</Tooltip>
                                            }
                                        >
                                            <Button
                                                onClick={() => addCollaboratorType()}
                                                variant="light"
                                                size="sm"
                                                className="rounded-circle"
                                            >
                                                <i className="material-icons">add</i>
                                            </Button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            placement="auto"
                                            overlay={
                                                <Tooltip>Seleccionar Filtrado</Tooltip>
                                            }
                                        >
                                            <Dropdown className="ml-3 mr-3">
                                                <Dropdown.Toggle
                                                    variant="light"
                                                    className="btn-sm font rounded-pill"
                                                >
                                                    <i className="material-icons">filter_list</i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {filters.map((item) => (
                                                        <Dropdown.Item
                                                            onClick={() => setTipoBusqueda(item)}
                                                            key={item.id}
                                                        >
                                                            {item.desc}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </OverlayTrigger>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    {loading ? (
                        <div className="d-flex justify-content-center">
                            <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                            />
                        </div>
                    ) : (
                        notificationBodiesLength > 0 && (
                            <>
                                <Card className="border-0">
                                    <Card.Body className="px-1 px-sm-2">
                                        <CustomTable columns={columns} data={notificationBodies} />
                                    </Card.Body>
                                </Card>
                                <CustomPagint
                                    limit={limit}
                                    setLimit={setLimit}
                                    offset={offset}
                                    setOffset={setOffset}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    dataLenght={notificationBodiesLength}
                                    pages={pages}
                                    pagFunc={getNotifications}
                                />
                            </>
                        )
                    )}
                    {!loading && notificationBodiesLength === 0 && notificationBodyError === "" && (
                        <Alert variant="info" className="my-4">
                            Aún no hay registros, comience creando algunos.
                        </Alert>
                    )}
                    {!!notificationBodyError && (
                        <Alert variant="danger" className="mt-4 mb-1 mx-3">
                            {notificationBodyError}
                        </Alert>
                    )}


                </Container >
            </div >
            <ModalNotification
                showModal={showModal}
                setShowModal={setShowModal}
                notification={editItem}
                edit={edit}
            />
            <HistoryModal
                showModal={showHistory}
                setShowModal={setShowHistory}
                correo_id={historyNotification}
            />

        </>
    );
}

export default MonitorNotificaciones;